import { useEffect } from 'react';
export function useCustomValidity(ref, customValidity) {
    useEffect(() => {
        if (ref.current) {
            ref.current.setCustomValidity(customValidity || '');
        }
    }, [customValidity, ref]);
}
//# sourceMappingURL=useCustomValidity.js.map